import { Component, EventEmitter, Input, Output } from '@angular/core';
import { oppositeSortDirection, SortDirection } from './table-sort-options/table-sort-options.component';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  imports: [TranslatePipe, MatIconButton, MatTooltip],
  selector: 'app-table-header',
  templateUrl: './table-header.component.html',
  standalone: true,
})
export class TableHeaderComponent {
  @Input()
  label: string;

  @Input()
  sort: SortDirection = null;

  @Input()
  defaultSort: SortDirection | null = 'asc';

  @Input()
  type: 'alpha' | 'numeric' | 'size' = 'alpha';

  @Input()
  sortable = true;

  @Output()
  toggleDirection: EventEmitter<SortDirection | null> = new EventEmitter<SortDirection | null>();

  toggleSortDirection(): void {
    if (this.sort) {
      this.sort = this.sort === this.defaultSort ? oppositeSortDirection(this.sort) : null;
    } else {
      this.sort = this.defaultSort;
    }

    this.toggleDirection.next(this.sort);
  }
}
